import { MenuItem, Switch } from '@mui/material';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { userIsAdmin } from 'lib/helpers';
import { useEffect, useState } from 'react';

interface Props {
  postId: number;
  accountUsername?: string;
  isFeatured: boolean;
  onIsFeaturedChange?: (status: string) => void;
}

export const FeaturePostMenuItem = ({
  postId, accountUsername, isFeatured, onIsFeaturedChange,
}: Props) => {
  const API = useApi();
  const currentUser = useCurrentUser();

  const [show, setShow] = useState<boolean|undefined>();

  const toggleIsFeatured = async () => {
    const v = !isFeatured;
    await API.toggleIsFeatured(postId, v);
    if (onIsFeaturedChange) onIsFeaturedChange('Featured status updated');
  };

  useEffect(() => {
    const getTeams = async () => {
      if (!currentUser) return;

      const data = await API.getTeams();
      const team = data.find(
        (t) => t.accounts.find((a) => a.username === accountUsername)
          && t.members.find((m) => m.userId === currentUser.id && m.role === 'manager'),
      );
      setShow(team !== undefined);
    };

    if (userIsAdmin(currentUser)) {
      setShow(true);
      return;
    }

    if (show === undefined) getTeams();
  }, [currentUser]);

  if (!show) return null;

  return (
    <MenuItem onClick={toggleIsFeatured}>
      Feature post
      <Switch
        checked={isFeatured}
        name="isPostFeatured"
        color="primary"
      />
    </MenuItem>
  );
};
